// First-touch affiliate attribution.
// Reads ?ref=CODE (or ?aff / ?affiliate) from the current URL exactly once
// and drops a 90-day cookie. Never overwrites an existing cookie so the
// first creator to send the visitor gets credit even if they later click
// another creator's link.
const COOKIE = "rsell_ref";
const MAX_AGE_DAYS = 90;

function readCookie(name) {
  if (typeof document === "undefined") return null;
  const m = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/[.$?*|{}()[\]\\/+^]/g, "\\$&") + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : null;
}

function writeCookie(name, value, days) {
  if (typeof document === "undefined") return;
  const d = new Date();
  d.setTime(d.getTime() + days * 864e5);
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${d.toUTCString()}; path=/; SameSite=Lax${secure}`;
}

const CODE_RE = /^[A-Z0-9_-]{2,40}$/;

// Call once on app mount. Reads ?ref (or ?aff / ?affiliate), writes cookie,
// then strips the param from the URL so we don't ship it into share links.
export function captureReferralOnLoad() {
  try {
    const params = new URLSearchParams(window.location.search);
    const raw = (params.get("ref") || params.get("aff") || params.get("affiliate") || "").trim().toUpperCase();
    if (raw && CODE_RE.test(raw) && !readCookie(COOKIE)) {
      writeCookie(COOKIE, raw, MAX_AGE_DAYS);
    }
    // Strip attribution params from the URL — cookie is the source of truth.
    if (params.has("ref") || params.has("aff") || params.has("affiliate")) {
      params.delete("ref"); params.delete("aff"); params.delete("affiliate");
      const qs = params.toString();
      const url = window.location.pathname + (qs ? "?" + qs : "") + window.location.hash;
      window.history.replaceState({}, "", url);
    }
  } catch { /* no-op */ }
}

export function getReferralCode() {
  const c = readCookie(COOKIE);
  return c && CODE_RE.test(c) ? c : "";
}

export function clearReferralCode() {
  writeCookie(COOKIE, "", -1);
}
